import { render, staticRenderFns } from "./YzUploadCard.vue?vue&type=template&id=1f141bba&scoped=true&lang=pug&"
import script from "./YzUploadCard.vue?vue&type=script&lang=js&"
export * from "./YzUploadCard.vue?vue&type=script&lang=js&"
import style0 from "./YzUploadCard.vue?vue&type=style&index=0&id=1f141bba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f141bba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
